import React from 'react';


export const AwsApiGateway = props => {
    return (
        <svg className={props.className} width="310" height="310" viewBox="0 0 310 310" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M283 137.042L220.848 139.617L180.559 137.047L247.199 130.66L283 137.042Z" fill="#634B1E"/>
            <path d="M247.055 133.45L283 137.042V64.636L247.055 46.661L244.295 49.641V130.369L247.055 133.45Z"
                  fill="#D9A740"/>
            <path d="M180.559 64.594L247.055 46.597V133.45L180.559 137.047V64.594Z" fill="#886A2A"/>
            <path d="M27 137.042L89.152 139.617L129.441 137.047L62.991 129.93L27 137.042Z" fill="#634B1E"/>
            <path d="M62.945 133.45L27 136.935V64.31L62.945 46.365L64.6 49.456V130.737L62.945 133.45Z" fill="#886A2A"/>
            <path d="M129.441 64.594L62.9453 46.597V133.45L129.441 137.047V64.594Z" fill="#D9A740"/>
            <path d="M283 174.486L220.848 171.91L180.559 174.481L246.909 181.188L283 174.486Z" fill="#FAD791"/>
            <path d="M247.054 178.078L282.999 174.486V246.891L247.054 264.866L245.166 260.755V181.772L247.054 178.078Z"
                  fill="#D9A740"/>
            <path d="M180.559 246.934L247.055 264.931V178.078L180.559 174.481V246.934Z" fill="#886A2A"/>
            <path d="M27 174.486L89.152 171.91L129.441 174.481L62.51 181.769L27 174.486Z" fill="#FAD791"/>
            <path d="M62.945 178.078L27 174.486V246.891L62.945 264.866L65.124 261.626V181.769L62.945 178.078Z"
                  fill="#886A2A"/>
            <path d="M129.441 246.934L62.9453 264.931V178.078L129.441 174.481V246.934Z" fill="#D9A740"/>
            <path d="M122.553 106.629L155.519 100.848L221.333 110.167L227.002 113.428L195.036 116.926L122.553 106.629Z"
                  fill="#634B1E"/>
            <path d="M187.447 106.629L154.481 100.848L85.833 111.5L82.998 113.428L114.964 116.926L187.447 106.629Z"
                  fill="#634B1E"/>
            <path d="M122.553 204.899L155.519 210.68L221.167 201.5L227.002 198.1L195.036 194.602L122.553 204.899Z"
                  fill="#FAD791"/>
            <path d="M187.447 204.899L154.481 210.68L85.333 200.833L82.998 198.1L114.964 194.602L187.447 204.899Z"
                  fill="#FAD791"/>
            <path
                d="M227.001 113.428V77.641L193.288 66.616V19.776L154.999 0.634033V0.635033L153.402 3.17803L153.111 305.766L154.999 309.657L193.288 290.515V244.912L227.001 233.887V198.1L193.288 204.035V107.493L227.001 113.428Z"
                fill="#D9A740"/>
            <path
                d="M116.711 19.776V66.616L82.998 77.641V113.428L116.711 107.493V204.035L82.998 198.1V233.887L116.711 244.912V290.515L155 309.657V0.634033L116.711 19.776Z"
                fill="#886A2A"/>
        </svg>
    )
};
